import { render } from "./PackageIcon.vue?vue&type=template&id=2c3d7c61&scoped=true&ts=true"
import script from "./PackageIcon.vue?vue&type=script&lang=ts"
export * from "./PackageIcon.vue?vue&type=script&lang=ts"

import "./PackageIcon.vue?vue&type=style&index=0&id=2c3d7c61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3d7c61"]])

export default __exports__